import { WidgetLoader } from './WidgetLoader'
import type { ChatWidgetAPI, WidgetOptions } from './types'

;(function () {
  'use strict'

  const loader = new WidgetLoader()

  ;(window as unknown as { ChatWidget?: ChatWidgetAPI }).ChatWidget = {
    init: (options: WidgetOptions) => loader.init(options),
    open: () => loader.open(),
    close: () => loader.close(),
    destroy: () => loader.destroy(),
    sendMessage: (content: string) => loader.sendMessage(content),
    applySettings: (settings: Record<string, unknown>) => loader.applySettings(settings),
    updateStyle: (variables: Record<string, string>) => loader.updateStyle(variables),
  }
})()
